// export const API_URL = "https://easystays.api.infinydev.com";
 export const API_URL = "https://api.direktstays.com";
// export const API_URL = "https://api.ezstays.online";
// export const API_URL = "http://192.168.1.33:4000";
// export const API_URL = "http://localhost:4000";

